import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { TaxYearProvider } from "./contexts/TaxYearContext";
import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import UploadExtract from "./pages/UploadExtract";
import Transactions from "./pages/Transactions";
import CACFPOverview from "./pages/CACFPOverview";
import Income from "./pages/Income";
import Expenses from "./pages/Expenses";
import Reports from "./pages/Reports";
import TurboTaxExport from "./pages/TurboTaxExport";
import Notes from "./pages/Notes";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import Settings from "./pages/Settings";
import Payment from "./pages/Payment";
import HelpCenter from "./pages/HelpCenter";
import OwnerConsole from "./pages/OwnerConsole";
import CustomerPortal from "./pages/CustomerPortal";
import GrantTracking from "./pages/GrantTracking";
import EquipmentAssets from "./pages/EquipmentAssets";
import Archive from "./pages/Archive";
import Pricing from "./pages/Pricing";
import YearEnd from "./pages/YearEnd";
import ActivateYear from "./pages/ActivateYear";
import OnTheGoVault from "./pages/OnTheGoVault";
import { Toaster } from "sonner";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="flex flex-col items-center gap-3">
        <div className="w-10 h-10 border-4 border-[#6D28D9] border-t-transparent rounded-full animate-spin" />
        <p className="text-slate-500 font-medium">Loading...</p>
      </div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/payment" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
      <Route path="/app" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Navigate to="/app/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="upload" element={<UploadExtract />} />
        <Route path="vault" element={<OnTheGoVault />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="cacfp" element={<CACFPOverview />} />
        <Route path="income" element={<Income />} />
        <Route path="expenses" element={<Expenses />} />
        <Route path="reports" element={<Reports />} />
        <Route path="turbotax" element={<TurboTaxExport />} />
        <Route path="notes" element={<Notes />} />
        <Route path="settings" element={<Settings />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="help" element={<HelpCenter />} />
        <Route path="owner" element={<OwnerConsole />} />
        <Route path="customer-portal" element={<CustomerPortal />} />
        <Route path="grant-tracking" element={<GrantTracking />} />
        <Route path="equipment" element={<EquipmentAssets />} />
        <Route path="archive" element={<Archive />} />
        <Route path="year-end" element={<YearEnd />} />
        <Route path="year-end/activate" element={<ActivateYear />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <TaxYearProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors closeButton />
        </BrowserRouter>
      </TaxYearProvider>
    </AuthProvider>
  );
}

export default App;
